import { BaseProyectaService } from "./base-proyecta.service";
import {
  Enums,
  Dictionary,
  Utilities,
  String,
  Constants,
} from "../../utils/utilities";
import {
  IAEAColumnDefinition,
  IProaFormBasicDataMasters,
  IBasicDataProjectProatDTO,
  IBasicDataProjectLineaIntervencion,
  ICmdBasicDataProjectProa,
  IBasicDataProjectProaBasicDTO,
  ProaTablaInSections,
  IProaTableData,
  IQueryProa,
  ICmdBasicDataProjectProaRRHH,
  ICmdBasicDataProjectProaFRYSPC,
  IProaDetailImpl,
  IDataConfig,
  IPProaBeneficiariosDuplicados
} from "@models/";

export interface IProaService {
  getProaBasicDataColumnDefinition(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
  getProaDataTableBaseline(budgetId: number): Promise<any>;
  getProaBudgetBeneficYear(budgetId: number): Promise<any>;
  getProaDataTableBenefic(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
  getProaDataPresupuesto(langId: number): Promise<any[]>;
  getAllFormMasters(langLabel: string): Promise<IProaFormBasicDataMasters>;
  getProjectNumber(): Promise<string>;
  getBasicBudgets(): Promise<any>;
  getAllBudgetDetails(): Promise<any>;
  getAllStepsData(): Promise<any>;
  getDetailDataBudget(idDatosBasicos: Number): Promise<any>;
  getStrategicLinesByidBudget(langId?: number): Promise<any>;
  getProjectByGrantCodeId(grantCodeId: number): Promise<any>;
  getProa(budgetId: number): Promise<IQueryProa>;
  saveProa(basicData: ICmdBasicDataProjectProa,aditionalSteps: IProaDetailImpl,rrhh: ICmdBasicDataProjectProaRRHH, tableConfig: any, itemsConfig: any, dupBeneficiaries:IPProaBeneficiariosDuplicados[], currentUser: string): Promise<any>;
  updateProa(basicData: ICmdBasicDataProjectProa,aditionalSteps: IProaDetailImpl,rrhh: ICmdBasicDataProjectProaRRHH, tableConfig: any, itemsConfig: any, dupBeneficiaries:IPProaBeneficiariosDuplicados[], currentUser: string): Promise<any>;
  savePlanning(items: any[]): Promise<any>;
  getDatosBasicos(idDatosBasicos: Number): Promise<any>;
  getFFRRBeneficAnio(budgetId: number): Promise<any>;
  getBudget(budgetId: number): Promise<any>;
  getSubProjectsInfo(budgetId: number): Promise<any>;
  getProjectsGrouped(budgetId: number): Promise<any>;
  getAllProjectsGrouped(): Promise<any>;
  getBudgetDetails(budgetId: number): Promise<any>;
  getSocialPartners(budgetId: number): Promise<ProaTablaInSections>;
  saveFRYSPC(_proaFRYSPC: any): Promise<any>;
  getLocations(budgetId: number): Promise<ProaTablaInSections>;
  getSummaryFieldsDefinition(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
  getDetailsFieldsDefinition(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
  getProaSummary(lang: string): Promise<any>;
  getAllProaSummary(): Promise<any>;
  getDefinitionColumnsProaFR(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
  deleteFile(relativeUrl: string): Promise<boolean>;
  getAllProa(): Promise<any>;
  getAllGlobalAdministration(langLabel: string): Promise<any>;
  getFilteredProaFilesToSearch(filters: string): Promise<any>;
  getDefinitionColumnsProaDocuments(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
  getProaSubproyectoFRStep1(budgetId: number): Promise<any>;
  getAllBeneficiariesDuplicates(): Promise<any>
  getBeneficiariesDuplicates(budgetId: number): Promise<any>;
  getCountryBeneficiariesDuplicates(place: number, field:string): Promise<any>;
  saveCountryDuplicate(objects: any, currentUser: string, list: string): Promise<any>;
  getAllBudgetsByProject(): Promise<any>;
  getBeneficiariesAnio(dataIds: number[], year: string): Promise<any>;
  deleteItems(listName: string, itemsToDelete: any[]): Promise<any>;
}

export class ProaService extends BaseProyectaService implements IProaService {
  //#region Public methods
  public async getBudget(budgetId: number): Promise<any> {
    const budget = await this.spListService.getItem<any>({
      listName: Enums.ListTypes.BaseBudget,
      itemId: budgetId,
      columnsToSelect: Constants.Selects.BUDGET_BASIC,
      expands: Constants.Expands.BUDGET_BASIC,
    });
    if(budget && budget.CodigoProyecto) budget.PPresCodProy = budget.CodigoProyecto?.Title;
    return budget;
  }

  public async getBudgetDetails(budgetId: number): Promise<any> {
    const parentBudget: any = await this.spListService.getItems<any>({
      listName: Enums.ListTypes.BaseBudget,
      filter: String.Format(Constants.FiltersFormats.FILTER_BY_ID, budgetId),
      columnsToSelect: Constants.Selects.BUDGET_BASIC,
      expands: Constants.Expands.BUDGET_BASIC,
    });

    const childsBudget: any = await this.spListService.getItems<any>({
      listName: Enums.ListTypes.BaseBudget,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET,
        budgetId
      ),
      columnsToSelect: Constants.Selects.BUDGET_BASIC,
      expands: Constants.Expands.BUDGET_BASIC,
    });

    let budgetIds = [parentBudget[0].Id];

    budgetIds = [
      ...budgetIds,
      ...childsBudget.map((x: any) => {
        return x.Id;
      }),
    ];

    let responseApi = await Promise.all(
      budgetIds.map(async (budgetId: number) => {
        return await this.spListService.getItems<any>({
          listName: Enums.ListTypes.DetailDataBudget,
          filter: String.Format(
            Constants.FiltersFormats.FILTER_BY_BUDGET,
            budgetId
          ),
          columnsToSelect: Constants.Selects.BUDGET_DETAILS,
          expands: Constants.Expands.BUDGET_DETAILS,
        });
      })
    );

    let finalArray: any = [];

    responseApi.forEach((x) => {
      finalArray = [...finalArray, ...x];
    });

    return finalArray;
  }

  public async getSubProjectsInfo(budgetId: number): Promise<any> {
    const result = await Promise.all([
      this.spListService.getItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep1,
        filter: String.Format(Constants.FiltersFormats.FILTER_BY_BUDGET, budgetId),
      }),
      this.spListService.getItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep2,
        filter: String.Format(Constants.FiltersFormats.FILTER_BY_BUDGET, budgetId),
      }),
      this.spListService.getItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep3,
        filter: String.Format(Constants.FiltersFormats.FILTER_BY_BUDGET, budgetId),
      }),
      this.spListService.getItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep4,
        filter: String.Format(Constants.FiltersFormats.FILTER_BY_BUDGET, budgetId),
      })
    ]);
    return result
  }

  public async getProjectsGrouped(budgetId: number): Promise<any> {
    return await this.spListService.getItems<any>({
      listName: Enums.ListTypes.ProyectaConfig,
      filter: String.Format(Constants.FiltersFormats.FILTER_BY_BUDGET, budgetId),
      columnsToSelect: Constants.Selects.PROJECTS_GROUPED,
      expands: Constants.Expands.PROJECTS_GROUPED
    })
  }

  public async getAllProjectsGrouped(): Promise<any> {
    return await this.spListService.getItems<any>({
      listName: Enums.ListTypes.ProyectaConfig,
      columnsToSelect: Constants.Selects.PROJECTS_GROUPED,
      expands: Constants.Expands.PROJECTS_GROUPED
    })
  }

  private async saveProjectsGrouped(tableConfig: any[], PPresPresupuestoId: number, itemsConfig: any): Promise<any> {
    try{
      if(Array.isArray(tableConfig)){
        let itemsToAdd: any[] = [];
        let itemsToUpdate: any[] = [];
        let itemsToDelete: any[] = itemsConfig;

        tableConfig.forEach((element: any) => {
          let SubProyectosAgrupadosId = this.createLookupObjectMultiValue(element.subProject)
          let item: IDataConfig = {PPresPresupuestoId, SubProyectosAgrupadosId, PPresCodSubvencionId: element.codePpal[0] }
          let itemExist = itemsConfig.find((item: any) => item.PPresCodSubvencionId === element.id)
          item.Id = itemExist?.Id;
          itemExist ? itemsToUpdate.push(item) : itemsToAdd.push(item);
          itemsToDelete = itemsToDelete.filter((x: any) => x.PPresCodSubvencionId !== element.id)
        });

        if(itemsToAdd.length) await this.spListService.addItemsBatch(Enums.ListTypes.ProyectaConfig, itemsToAdd)
        if(itemsToUpdate.length) await this.spListService.updateItemsBatch(Enums.ListTypes.ProyectaConfig, itemsToUpdate)
        if(itemsToDelete.length) await this.spListService.deleteItemsBatch(Enums.ListTypes.ProyectaConfig, itemsToDelete)
      }
    } catch (error) {
      console.log(error)
    }
  }

  public async getDefinitionColumnsProaFR(
    langId: number
  ): Promise<Dictionary<string, IAEAColumnDefinition>> {
    return await this.getDefinitionColumns(
      langId,
      Enums.ListTypes.ProaColumDefinitionFR
    );
  }

  public async getLocations(budgetId: number): Promise<ProaTablaInSections> {
    let frLocations = await this.spListService.getItems<IProaTableData>({
      listName: Enums.ListTypes.ProaSubproyectoFRStep3,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET,
        budgetId
      ),
      expands: Constants.Expands.PROA_SECTION_4_LOCATION,
      columnsToSelect: Constants.Selects.PROA_SECTION_4_LOCATION,
    });

    let adts: IProaTableData[] = [];
    let zonas: IProaTableData[] = [];

    adts = frLocations.filter(
      (location) => !Utilities.isNullObject(location.PProaAdt)
    );
    zonas = frLocations.filter(
      (location) => !Utilities.isNullObject(location.PProaLocation)
    );

    return new Promise((resolve, reject) => {
      let returnElement: ProaTablaInSections = {
        adts: adts,
        zonas: zonas,
      };
      return resolve(returnElement);
    });
  }

  public async getBeneficiariesAnio(dataIds: number[], year: string): Promise<any> {
    let baseData = await this.spListService.getItems<any>({
      listName: Enums.ListTypes.BaseFFRRBeneficiarios,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_YEAR,
        year
      ),
    });

    if(baseData) baseData = baseData.filter(x => dataIds.includes(x.PPresPresupuestoId))
    return baseData
  }

  public async getProaSubproyectoFRStep1(budgetId: number): Promise<any> {
    return await this.spListService.getItems<any>({
      listName: Enums.ListTypes.ProaSubproyectoFRStep1,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET,
        budgetId
      ),
      columnsToSelect: Constants.Selects.SUBPROJECTS_PROA,
      expands: Constants.Expands.SUBPROJECTS_PROA
    });
  }

  public async getAllBeneficiariesDuplicates(): Promise<any> {
    return await this.spListService.getItems<any>({
      listName: Enums.ListTypes.PProaBeneficiariosDuplicados,
      columnsToSelect: Constants.Selects.SUBPROJECTS_PROA,
      expands: Constants.Expands.SUBPROJECTS_PROA
    });
  }

  public async getBeneficiariesDuplicates(budgetId: number): Promise<any> {
    return await this.spListService.getItems<any>({
      listName: Enums.ListTypes.PProaBeneficiariosDuplicados,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET,
        budgetId
      ),
      columnsToSelect: Constants.Selects.SUBPROJECTS_PROA,
      expands: Constants.Expands.SUBPROJECTS_PROA
    });
  }

  public async getCountryBeneficiariesDuplicates(place: number, field:string): Promise<any> {
    return await this.spListService.getItems<any>({
      listName: Enums.ListTypes.PProaBeneficiariosDuplicadosPais,
      filter: String.Format(
        `${field} eq {0}`,
        place
      ),
      columnsToSelect: Constants.Selects.SUBPROJECTS_PROA,
      expands: Constants.Expands.SUBPROJECTS_PROA
    });
  }

  public async saveCountryDuplicate(objects: IPProaBeneficiariosDuplicados[], currentUser: string, list: string): Promise<any> {
    try {
      let currentUsu = await this.spWebService.ensureUser(currentUser)
      let itemsToAdd: any[] = []
      let itemsToUpdate: any[] = []

      objects.forEach((item: any) => {
        item.PProaModifiedById = currentUsu.Id
        item.Id ? itemsToUpdate.push(item) : itemsToAdd.push(item)
      });

      if(itemsToAdd.length) await this.spListService.addItemsBatch(list, itemsToAdd)
      if(itemsToUpdate.length) await this.spListService.updateItemsBatch(list, itemsToUpdate)

    } catch (error) {
      console.log(error)
    }
  }

  private async saveDuplicate(objects: IPProaBeneficiariosDuplicados[], currentUser: string, list: string): Promise<any> {
    try {
      if(objects.length){
        let currentUsu = await this.spWebService.ensureUser(currentUser);
        let itemsToAdd: any[] = [];
        let itemsToUpdate: any[] = [];

        let duplicatesSP = await this.getBeneficiariesDuplicates(objects[0].PPresPresupuestoId);
        
        objects.forEach((item: any) => {
          let elementSP = duplicatesSP.find((dupSp:any) => (dupSp.PPresCodSubvencionId === item.PPresCodSubvencionId && dupSp.PPresuAnio == item.PPresuAnio && item.PProaFRStep1Id == dupSp.PProaFRStep1Id) )?.Id
          item.PProaModifiedById = currentUsu.Id;
          if(elementSP){
            item.Id = elementSP;
            itemsToUpdate.push(item);
          }else if(item.PFFRRTotal) itemsToAdd.push(item);
        });

        if(itemsToAdd.length) await this.spListService.addItemsBatch(list, itemsToAdd);
        if(itemsToUpdate.length) await this.spListService.updateItemsBatch(list, itemsToUpdate);
      }

    } catch (error) {
      console.log(error)
    }
  }

  public async getProaDataTableBaseline(budgetId: number): Promise<any> {
    let result: any[] = [];
    const baseData = await this.spListService.getItems<any>({
      listName: Enums.ListTypes.ProaSubproyectoFRStep1,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET,
        budgetId
      ),
    });
    if (baseData.length > 0) {
      const baseDataItem = baseData[0];
      const years = await this.spListService.getItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep1Anios,
        filter: String.Format(
          Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP1,
          baseDataItem.Id
        ),
        order: Enums.ProaBasicFields.Meta,
      });
      if (years.length > 0) {
        result = this.mappingBaseLineData(baseDataItem, years);
      }
    }
    return result;
  }

  private mappingBaseLineData(base: any, years: any) {
    return years
      .map((year: any) => {
        if (!Utilities.isNullEmptyObject(year[Enums.ProaBasicFields.Meta])) {
          return {
            IdBaseData: base.Id,
            IdMetaData: year.Id,
            OCTAVIAFechaInicio: base.OCTAVIAFechaInicio,
            OCTAVIAFechaFinalizacion: base.OCTAVIAFechaFinalizacion,
            PPresIndicadorLineaEstrategica:
              base.PPresIndicadorLineaEstrategica1Id,
            PFFRRLineaBase: base.PFFRRLineaBase,
            PPresAnioMeta: year.PPresAnioMeta,
            PProaAnioValue: year.PProaAnioValue,
          };
        }
      })
      .filter((x: any) => x !== undefined);
  }

  public async getProaBudgetBeneficYear(budgetId: number): Promise<any> {
    const budget = await this.spListService.getItems<any>({
      listName: Enums.ListTypes.BaseFFRRBeneficiarios,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET,
        budgetId
      ),
    });
    return budget;
  }

  public async getSummaryFieldsDefinition(
    langId: number
  ): Promise<Dictionary<string, IAEAColumnDefinition>> {
    return await this.getDefinitionColumns(
      langId,
      Enums.ListTypes.ProaSummaryColumnDefinition
    );
  }

  public async getDetailsFieldsDefinition(
    langId: number
  ): Promise<Dictionary<string, IAEAColumnDefinition>> {
    return await this.getDefinitionColumns(
      langId,
      Enums.ListTypes.ProaDetailsColumnDefinition
    );
  }

  public async getProaSummary(lang: string): Promise<any> {
    return await this.spListService.getItems({
      listName: Enums.ListTypes.ProaSummaryData,
      filter: String.Format(
        Constants.FiltersFormats.LANGUAGE_FILTER_SUMMARY_PROA,
        lang
      ),
    });
  }

  public async getAllProaSummary(): Promise<any> {
    return await this.spListService.getItems({
      listName: Enums.ListTypes.ProaSummaryData,
    });
  }

  public async getProaBasicDataColumnDefinition(
    langId: number
  ): Promise<Dictionary<string, IAEAColumnDefinition>> {
    return await this.getDefinitionColumns(
      langId,
      Enums.ListTypes.ProaColumDefinitionBasicData
    );
  }

  public async getProaDataTableBenefic(
    langId: number
  ): Promise<Dictionary<string, IAEAColumnDefinition>> {
    return await this.getDefinitionColumns(
      langId,
      Enums.ListTypes.ProaDataTableBenefic
    );
  }

  public async getProaDataPresupuesto(): Promise<any[]> {
    return await this.spListService.getItems<any>({
      listName: Enums.ListTypes.BaseBudget,
      columnsToSelect: Constants.Selects.BUDGET_BASIC,
      expands: Constants.Expands.BUDGET_BASIC,
    });
  }

  public async getAllFormMasters(
    langLabel: string
  ): Promise<IProaFormBasicDataMasters> {
    const result = await Promise.all([
      this.getRegions(langLabel),
      this.getCountries(langLabel),
      this.getGrantCodes(langLabel),
      this.getStrategicLines(langLabel),
      this.getInterventionLines(langLabel),
      this.getTagsProjec(langLabel),
      this.getTypeRRHH(langLabel),
      this.getcollective(langLabel),
      this.getYears(),
      this.getGaps(langLabel),
      this.getFFCCFinancingEntities(langLabel),
      this.getFFRRFinancingEntities(langLabel),
      this.getProaLocalization(),
      this.getProaAdts(langLabel),
      this.getSLEP(langLabel),
      this.getIntermediateResult(langLabel),
      this.getProducts(langLabel),
      this.getProductsIndicator(langLabel),
      this.getIntermediateResultIndicator(langLabel),
      this.getBudgetTypes(langLabel),
      this.getCounterpartType(langLabel),
      this.getMeasureUnits(langLabel),
    ]) as any;
    return {
      regions: result[0],
      countries: result[1],
      countriesAndRegions: [...result[0].map((value:any) => {
        return {
          ...value,
          Id: Constants.Globals.PREFFIX_RG + value.Id.toString(),
          ID: Constants.Globals.PREFFIX_RG + value.ID.toString(),
        }
      }), ...result[1]],
      grantCodes: this.processGrantCodes(result[2]),
      strategicLines: result[3],
      interventionLines: result[4],
      tags: result[5],
      typeRRHH: result[6],
      collective: result[7],
      years: result[8],
      gaps: result[9],
      ffccFinancer: result[10],
      ffrrFinancer: result[11],
      allFinancers: [...result[10], ...result[11]],
      proaLocalization: result[12],
      proaAdt: result[13],
      implementators: result[14],
      intermediateResults: result[15],
      products: result[16],
      productsIndicators: result[17],
      intermediateResultsIndicator: result[18],
      budgetTypes: result[19],
      counterpartType: result[20],
      measureUnits: result[21],
    };
  }

  public async getProjectNumber(): Promise<string> {
    const consecutive = await this.getConsecutive(
      Enums.ConsecutiveKeys.PresCodigoProyecto
    );
    return Utilities.convertNumToConsecutive(
      consecutive.PMaxNumLenth,
      consecutive.PContador
    );
  }

  public async getBasicBudgets() {
    return await this.spListService.getItems({
      listName: Enums.ListTypes.BaseBudget,
      columnsToSelect: Constants.Selects.BUDGET_BASIC,
      expands: Constants.Expands.BUDGET_BASIC
    });
  }

  public async getDetailDataBudget(idDatosBasicos: number) {
    const datosBasicos = await this.spListService.getItems<any>({
      listName: Enums.ListTypes.DetailDataBudget,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET,
        idDatosBasicos
      ),
    });
    return this.mapBasicDataEntityToCurrentBasicData(datosBasicos[0]);
  }

  public async getStrategicLinesByidBudget(budgetId: number) {
    const budget = await this.spListService.getItem<any>({
      listName: Enums.ListTypes.BaseBudget,
      itemId: budgetId,
      columnsToSelect: Constants.Selects.BUDGET_BASIC,
      expands: Constants.Expands.BUDGET_BASIC,
    });
    const strategicLine = (
      await this.spListService.getItems<any>({
        listName: Enums.ListTypes.StrategicLine,
        columnsToSelect: Constants.Selects.OCTAVIA_CODE,
        filter: String.Format(
          Constants.FiltersFormats.FILTER_BY_INTERVENTION_LINE,
          budget.OCTAVIALineaIntervencionId
        ),
      })
    )[0];
    return strategicLine;
  }

  public async getProjectByGrantCodeId(grantCodeId: number): Promise<any> {
    let items = await this.spListService.getItems<any>({
      listName: Enums.ListTypes.GrantCode,
      filter: String.Format(Constants.FiltersFormats.FILTER_BY_ID, grantCodeId),
    });

    if (items.length === 0) {
      return null;
    }
    return await this.spListService.getItems<any>({
      listName: Enums.ListTypes.Project,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_ID,
        items[0].OCTAVIACodigoProyectoId
      ),
    });
  }

  public async saveProa(
    basicData: ICmdBasicDataProjectProa,
    aditionalSteps: IProaDetailImpl,
    rrhh: ICmdBasicDataProjectProaRRHH,
    tableConfig: any,
    itemsConfig: any,
    dupBeneficiaries: IPProaBeneficiariosDuplicados[],
    currentUser: string
  ) {
    const result = await this.spListService.addItem({
      listName: Enums.ListTypes.BaseProa,
      item: basicData,
    });

    let sectionsData = { ...aditionalSteps };
    sectionsData.Id_x0020_PresupuestoId = basicData.PPresPresupuestoId;

    await this.saveUpdateProaStepsData(sectionsData);

    await this.saveUpdateProaRRHH(rrhh);

    await this.saveProjectsGrouped(tableConfig, basicData.PPresPresupuestoId, itemsConfig);
    await this.saveDuplicate(dupBeneficiaries, currentUser, Enums.ListTypes.PProaBeneficiariosDuplicados);

    return result.item;
  }

  public async getProa(budgetId: number): Promise<IQueryProa> {
    const proa = await this.spListService.getItem<any>({
      listName: Enums.ListTypes.BaseBudget,
      itemId: budgetId,
      columnsToSelect: Constants.Selects.BUDGET_BASIC,
      expands: Constants.Expands.BUDGET_BASIC,
    });

    const strategicLine = (
      await this.spListService.getItems<any>({
        listName: Enums.ListTypes.StrategicLine,
        columnsToSelect: Constants.Selects.ESTRATEGICLINE_BASIC,
        filter: String.Format(
          Constants.FiltersFormats.FILTER_BY_INTERVENTION_LINE,
          proa.OCTAVIALineaIntervencionId
        ),
      })
    )[0];

    //Proa details
    const proaDataSteps = (
      await this.spListService.getItems<IProaDetailImpl>({
        listName: Enums.ListTypes.ProaRGSecciones,
        columnsToSelect: Constants.Selects.PROA_SECTIONS,
        filter: String.Format(Constants.FiltersFormats.BUDGET_ID, budgetId),
      })
    )[0];

    const rrhhData = (
      await this.spListService.getItems<any>({
        listName: Enums.ListTypes.BaseRRHH,
        filter: String.Format(
          Constants.FiltersFormats.FILTER_BY_BUDGET,
          budgetId
        ),
        columnsToSelect: Constants.Selects.PROA_RRHH,
        expands: Constants.Expands.PROA_RRHH,
      })
    )[0];

    const datosBasicos = await this.spListService.getItems<
      IBasicDataProjectProaBasicDTO
    >({
      listName: Enums.ListTypes.BaseProa,
      columnsToSelect: Constants.Selects.PROA_BASIC,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET,
        budgetId
      ),
    });

    return new Promise((resolve, reject) => {
      let response: IQueryProa = {
        currentBudget: this.mappBudgetEntityToCurrentBudget(
          proa,
          strategicLine
        ),
        aditionalSteps: proaDataSteps,
        proaRRHH: rrhhData,
        datosBasicos: this.mapBasicDataEntityToCurrentBasicData(
          datosBasicos[0]
        ),
      };

      return resolve(response);
    });
  }

  public async getSocialPartners(
    budgetId: number
  ): Promise<ProaTablaInSections> {
    let ftImplementers = await this.spListService.getItems<IProaTableData>({
      listName: Enums.ListTypes.ProaSubproyectoFRStep2,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET,
        budgetId
      ),
      expands: ["OCTAVIASLEP"],
      columnsToSelect: ["*", "OCTAVIASLEP/Title"],
    });

    return new Promise((resolve, reject) => {
      let returnElement: ProaTablaInSections = {
        adts: [...ftImplementers],
        zonas: null,
      };

      return resolve(returnElement);
    });
  }

  public async saveFRYSPC(dataRHYSPC: ICmdBasicDataProjectProaFRYSPC) {
    const result = await this.spListService.addItem({
      listName: Enums.ListTypes.ProaRGSecciones,
      item: dataRHYSPC,
    });
    return result.item;
  }

  public async getFFRRBeneficAnio(budgetId: number): Promise<any> {
    const basicDataFFRRBeneficiarios = await this.spListService.getItems<any>({
      listName: Enums.ListTypes.BaseFFRRBeneficiarios,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET,
        budgetId
      ),
    });
    return basicDataFFRRBeneficiarios;
  }

  public async getDatosBasicos(idDatosBasicos: number) {
    const datosBasicos = await this.spListService.getItems<
      IBasicDataProjectProaBasicDTO
    >({
      listName: Enums.ListTypes.BaseProa,
      columnsToSelect: Constants.Selects.PROA_BASIC,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET,
        idDatosBasicos
      ),
    });

    return this.mapBasicDataEntityToCurrentBasicData(datosBasicos[0]);
  }

  public async updateProa(
    basicData: ICmdBasicDataProjectProa,
    aditionalSteps: IProaDetailImpl,
    rrhh: ICmdBasicDataProjectProaRRHH,
    tableConfig: any,
    itemsConfig: any,
    dupBeneficiaries: IPProaBeneficiariosDuplicados[],
    currentUser: string
  ) {
    const _item = { ...basicData };
    const result = await this.spListService.updateItem({
      listName: Enums.ListTypes.BaseProa,
      item: _item,
      itemId: _item.Id,
    });

    let sectionsData = { ...aditionalSteps };
    sectionsData.Id_x0020_PresupuestoId = basicData.PPresPresupuestoId;

    await this.saveUpdateProaStepsData(sectionsData);

    await this.saveUpdateProaRRHH(rrhh);

    await this.saveProjectsGrouped(tableConfig, basicData.PPresPresupuestoId, itemsConfig);
    await this.saveDuplicate(dupBeneficiaries, currentUser, Enums.ListTypes.PProaBeneficiariosDuplicados);

    return result.item;
  }

  public async savePlanning(items: any[]): Promise<any> {
    try {
      await this.spListService.updateItemsBatch(Enums.ListTypes.ProaSummaryData, items)
    } catch (error) {
      console.log(error)
    }
  }

  public async getAllBudgetsByProject(): Promise<any[]> {
    return await this.spListService.getItems<any>({
      listName: Enums.ListTypes.BaseBudget,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_PPRESTIPOPRESID,
        Enums.SedeOn.Sede
      ),
      columnsToSelect: Constants.Selects.BUDGET_BASIC,
      expands: Constants.Expands.BUDGET_BASIC
    });
  }
  public async getAllBudgetDetails(): Promise<any[]> {
    return await this.spListService.getPagedItems<any>({
      listName: Enums.ListTypes.DetailDataBudget,
      columnsToSelect: Constants.Selects.BUDGET_DETAILS,
      expands: Constants.Expands.BUDGET_DETAILS,
    });
  }
  public async getAllRRHH(): Promise<any[]> {
    return await this.spListService.getItems<any>({
      listName: Enums.ListTypes.BaseRRHH,
    });
  }

  public async getAllStepsData(): Promise<any> {
    const result = await Promise.all([
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep1,
        columnsToSelect: Constants.Selects.SUBPROJECTS_PROA,
        expands: Constants.Expands.SUBPROJECTS_PROA
      }), //0
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep1Anios,
      }), //1
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep2,
      }), //2
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios,
      }), //3
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep3,
        columnsToSelect: Constants.Selects.PROA_SECTION_3_IMPLEMENTERS,
				expands: Constants.Expands.PROA_SECTION_3_IMPLEMENTERS,	
      }), //4
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
      }), //5
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep4,
      }), //6
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep4LineaBase,
      }), //7
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep4LineaBaseAnios,
      }), //8
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep4Productos,
      }), //9
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep4ProductosAnios,
      }), //10
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4,
      }), //11
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4Objetivo,
        columnsToSelect: Constants.Selects.FEStep4Medida,
        expands: Constants.Expands.FEStep4Medida
      }), //12
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4ObjetivoAnios,
      }), //13
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4Actividad,
        columnsToSelect: Constants.Selects.FEStep4Medida,
        expands: Constants.Expands.FEStep4Medida
      }), //14
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios,
      }), //15
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4Resultados,
      }), //16
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetalles,
        columnsToSelect: Constants.Selects.FEStep4Medida,
        expands: Constants.Expands.FEStep4Medida
      }), //17
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetallesAnios,
      }), //18
      this.spListService.getPagedItems<any>({ listName: Enums.ListTypes.BaseProa }), // 19
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.BaseFFRRBeneficiarios,
      }), //20 
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4MRI,
        columnsToSelect: Constants.Selects.PProaStep4MRI,
        expands: Constants.Expands.PProaStep4MRI
      }), //21
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4MRIAnios,
      }), //22
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStepSDC,
      }), //23
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStepSDCAnios,
      }), //24
    ]);

    return {
      step1: {
        base: result[0],
        years: result[1],
        yearsBeneficiaries: result[20],
      },
      step2: {
        base: result[2],
        years: result[3],
      },
      step3: {
        base: result[4],
        years: result[5],
      },
      step4: {
        objetives: result[11],
        specificObjetives: {
          base: result[12],
          years: result[13],
        },
        results: {
          base: result[16],
          details: result[17],
          years: result[18],
        },
        activities: {
          base: result[14],
          years: result[15],
        },
        mri: {
          base: result[21],
          years: result[22],
        },
      },
      stepSDC: {
        base: result[23],
        years: result[24],
      },
      base: result[19],
    };
  }

  public async getStepsData(): Promise<any> {
    const result = await Promise.all([
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep1,
      }), //0
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep1Anios,
      }), //1
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep2,
      }), //2
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios,
      }), //3
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep3,
      }), //4
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
      }), //5
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep4,
      }), //6
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep4LineaBase,
      }), //7
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep4LineaBaseAnios,
      }), //8
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep4Productos,
      }), //9
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep4ProductosAnios,
      }), //10
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4,
      }), //11
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4Objetivo,
        columnsToSelect: Constants.Selects.FEStep4Medida,
        expands: Constants.Expands.FEStep4Medida
      }), //12
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4ObjetivoAnios,
      }), //13
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4Actividad,
        columnsToSelect: Constants.Selects.FEStep4Medida,
        expands: Constants.Expands.FEStep4Medida
      }), //14
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios,
      }), //15
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4Resultados,
      }), //16
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetalles,
        columnsToSelect: Constants.Selects.FEStep4Medida,
        expands: Constants.Expands.FEStep4Medida
      }), //17
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetallesAnios,
      }), //18
      this.spListService.getPagedItems<any>({ listName: Enums.ListTypes.BaseProa }), // 19
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.BaseFFRRBeneficiarios,
      }), //20 
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4MRI,
        columnsToSelect: Constants.Selects.PProaStep4MRI,
        expands: Constants.Expands.PProaStep4MRI
      }), //21
      this.spListService.getPagedItems<any>({
        listName: Enums.ListTypes.ProaSubproyectoFEStep4MRIAnios,
      }), //22
    ]);

    return {
      step1: {
        base: result[0],
        years: result[1],
        yearsBeneficiaries: result[20],
        yearsMin: Math.min(
          ...this.getRange(result[1], "PPresAnioMeta", "PProaAnioValue")
        ),
        yearsMax: Math.max(
          ...this.getRange(result[1], "PPresAnioMeta", "PProaAnioValue")
        ),
        benficiaresMin: Math.min(
          ...this.getRange(result[20], "PPresuAnio", undefined, [
            "PFFRRTotalHombres",
            "PFRRTotalMujeres",
            "PPresTotalAnio",
          ])
        ),
        beneficiariesMax: Math.max(
          ...this.getRange(result[20], "PPresuAnio", undefined, [
            "PFFRRTotalHombres",
            "PFRRTotalMujeres",
            "PPresTotalAnio",
          ])
        ),
      },
      step2: {
        base: result[2],
        years: result[3],
        yearsMin: Math.min(
          ...this.getRange(result[3], "PPresAnioMeta", "PProaAnioValue")
        ),
        yearsMax: Math.max(
          ...this.getRange(result[3], "PPresAnioMeta", "PProaAnioValue")
        ),
      },
      step3: {
        base: result[4],
        years: result[5],
        yearsMin: Math.min(
          ...this.getRange(result[5], "PPresAnioMeta", "PProaAnioValue")
        ),
        yearsMax: Math.max(
          ...this.getRange(result[5], "PPresAnioMeta", "PProaAnioValue")
        ),
      },
      step4: {
        objetivos: result[11],
        objetivoEspecifico: {
          base: result[12],
          years: result[13],
          yearsMin: Math.min(
            ...this.getRange(result[13], "PPresAnioMeta", "PProaAnioValue")
          ),
          yearsMax: Math.max(
            ...this.getRange(result[13], "PPresAnioMeta", "PProaAnioValue")
          ),
        },
        resultado: {
          base: result[16],
          detalle: result[17],
          years: result[18],
          yearsMin: Math.min(
            ...this.getRange(result[18], "PPresAnioMeta", "PProaAnioValue")
          ),
          yearsMax: Math.max(
            ...this.getRange(result[18], "PPresAnioMeta", "PProaAnioValue")
          ),
        },
        actividad: {
          base: result[14],
          years: result[15],
          yearsMin: Math.min(
            ...this.getRange(result[15], "PPresAnioMeta", "PProaAnioValue")
          ),
          yearsMax: Math.max(
            ...this.getRange(result[15], "PPresAnioMeta", "PProaAnioValue")
          ),
        },
        mri: {
          base: result[21],
          years: result[22],
          yearsMin: Math.min(
            ...this.getRange(result[22], "PPresAnioMeta", "PProaAnioValue")
          ),
          yearsMax: Math.max(
            ...this.getRange(result[22], "PPresAnioMeta", "PProaAnioValue")
          ),
        },
        
      },
      base: result[19],
    };
  }
  private getRange(
    data: any,
    paramToSelect: string,
    paramToCondition?: string,
    paramToConditionMulti?: Array<string>
  ) {
    let filterData = data;
    if (paramToCondition != null && paramToCondition != undefined) {
      filterData = data.filter(
        (item: any) => item[paramToCondition] > 0 && item[paramToSelect] > 1970
      );
    }

    if (paramToConditionMulti != null && paramToConditionMulti != undefined) {
      filterData = data.filter((item: any) => {
        let result = false;
        paramToConditionMulti.forEach((condition: string) => {
          if (item[condition]) {
            result = true;
          }
        });
        return result;
      });
    }
    const result = filterData.map((value: any) => {
      return Number(value[paramToSelect]);
    });
    return result.length > 0 ? result : [0];
  }

  public async getAllProa(): Promise<any> {
    const result = await Promise.all([
      this.getAllBudgetsByProject(),
      this.getAllBudgetDetails(),
      this.getStepsData(),
      this.getAllRRHH(),
    ]);
    return {
      budgets: result[0],
      details: result[1],
      fSteps: result[2],
      rrhh: result[3],
    };
  }
  public async getAllGlobalAdministration(langLabel: string): Promise<any> {
    const result = await Promise.all([
      this.getAdminList(langLabel),
      this.getAminSecitions(langLabel),
      this.getApplications(),
    ]);
    return {
      lists: result[0],
      sections: result[1],
      apps: result[2],
    };
  }

  public async getDefinitionColumnsProaDocuments(
    langId: number
  ): Promise<Dictionary<string, IAEAColumnDefinition>> {
    return await this.getDefinitionColumns(
      langId,
      Enums.ListTypes.ProaDocumentosDefinicionColumnas
    );
  }

  public async getFilteredProaFilesToSearch(filters: string): Promise<any> {
    try {
        const items = await this.spListService.getItems<any>({
          listName: Enums.ListTypes.ProaDocuments,
          filter: filters,
          columnsToSelect: Constants.Selects.SELECT_PROA_FILE_BY_ITEM,
          expands: Constants.Expands.SELECT_FILE_BY_ITEM_EXPAND,
          top: 200
        });
        return items
    } catch (error) {
        console.log(error);
        console.debug((error as any).message);

        return {
            OperationSuccess: false
        };
    }

}

  //#endregion

  //#region Private methods
  private processGrantCodes(grantCodes: any): any {
    return grantCodes.map((x: any) => {
      x.Title = x.OCTAVIACodigoSubvencion;
      return x;
    });
  }

  private mapBasicDataEntityToCurrentBasicData(
    datosBasicosEntity: IBasicDataProjectProaBasicDTO
  ) {
    const currentBasicData: any = {
      PPresPresupuestoId: datosBasicosEntity?.PPresPresupuestoId,
      OCTAVIAFechaInicio: datosBasicosEntity?.OCTAVIAFechaInicio,
      OCTAVIAFechaFinalizacion: datosBasicosEntity?.OCTAVIAFechaFinalizacion,
      Id: datosBasicosEntity?.Id,
      Title: datosBasicosEntity?.Title,
      OCTAVIAEtiquetasId: datosBasicosEntity?.OCTAVIAEtiquetasId,
      PlanificacionAprobada: datosBasicosEntity?.PlanificacionAprobada,
    };
    return currentBasicData;
  }

  private mappBudgetEntityToCurrentBudget(
    budgetEntity: IBasicDataProjectProatDTO,
    strategicLineEntity: IBasicDataProjectLineaIntervencion
  ) {
    const currentBudget: any = {
      PPresTipoPresId: budgetEntity.PPresTipoPresId,
      PPresCodProy: budgetEntity.CodigoProyecto?.Title,
      PPresNumProy: budgetEntity.PPresNumProy,
      Id: budgetEntity.Id,
      tituloLineaEstrategica: strategicLineEntity?.Id,
      isRegion: false,
    };
    if (budgetEntity.PPresTipoPresId !== Enums.SystemParameters.BudgetTypeOn) {
      currentBudget.LineaIntervencionId = [
        {
          id: budgetEntity.OCTAVIALineaIntervencion.Id,
          label: budgetEntity.OCTAVIALineaIntervencion.Title,
        },
      ];
      currentBudget.Title = budgetEntity.Title;
    }
    if (!Utilities.isNullObject(budgetEntity.OCTAVIARegion)) {
      currentBudget.isRegion = true;
      currentBudget.RegionCountry = [
        {
          id: Constants.Globals.PREFFIX_RG + budgetEntity.OCTAVIARegion.Id,
          label: budgetEntity.OCTAVIARegion.Title,
        },
      ];
    }

    if (!Utilities.isNullObject(budgetEntity.OCTAVIAPais)) {
      currentBudget.Country = [
        {
          id: budgetEntity.OCTAVIAPais.Id,
          label: budgetEntity.OCTAVIAPais.Title,
        },
      ];
    }

    return currentBudget;
  }

  private async saveUpdateProaStepsData(aditionalSteps: IProaDetailImpl) {
    if (aditionalSteps.Id) {
      await this.spListService.updateItem({
        listName: Enums.ListTypes.ProaRGSecciones,
        item: aditionalSteps,
        itemId: aditionalSteps.Id,
      });
    } else {
      await this.spListService.addItem({
        listName: Enums.ListTypes.ProaRGSecciones,
        item: aditionalSteps,
      });
    }
  }

  private async saveUpdateProaRRHH(rrhh: ICmdBasicDataProjectProaRRHH) {
    if (rrhh.Id) {
      await this.spListService.updateItem({
        listName: Enums.ListTypes.BaseRRHH,
        item: rrhh,
        itemId: rrhh.Id,
      });
    } else {
      await await this.spListService.addItem({
        listName: Enums.ListTypes.BaseRRHH,
        item: rrhh,
      });
    }
  }
  //#endregion

  public async deleteFile(relativeUrl: string) {
    await this.spFileService.deleteFile(relativeUrl);
    return Promise.resolve(true);
  }

  public async deleteItems(listName: string, itemsToDelete: any[]): Promise<any> {
    return await this.spListService.deleteItemsBatch(listName, itemsToDelete)
  }

  private createLookupObjectMultiValue(values: any) {
    return { '__metadata': { type: 'Collection(Edm.Int32)' }, results: values };
  }
}
